import { render, staticRenderFns } from "./cpt-game-selector.vue?vue&type=template&id=9d5f0de4"
import script from "./cpt-game-selector.vue?vue&type=script&lang=js"
export * from "./cpt-game-selector.vue?vue&type=script&lang=js"
import style0 from "./cpt-game-selector.vue?vue&type=style&index=0&id=9d5f0de4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.11_cache-loader@2.0.1_webpack@4.47.0__css-loader@1.0_46uom3ic6e7zmr6qh5t5ayckj4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports